import { Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-salnes-ivory text-salnes-stone text-sm"
        data-testid="auth-loading"
      >
        <LoadingText />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function LoadingText() {
  const { t } = useTranslation();
  return <>{t("common.loading")}</>;
}
